import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { getInitialDictionariesLoaded } from "../../modules/info-data/info-data-selectors";
import { loadDictionariesAction } from "../../reducers";
import { useAppDispatch } from "../../store";

export function useDictionaryLoader(): boolean {
  const initialDictionariesLoaded = useSelector(getInitialDictionariesLoaded);
  const dispatch = useAppDispatch();

  const fetchDictionaries = useCallback(() => {
    if (initialDictionariesLoaded) {
      return;
    }
    dispatch(loadDictionariesAction());
  }, [dispatch, initialDictionariesLoaded]);

  useEffect(() => {
    fetchDictionaries();
  }, [fetchDictionaries]);

  return initialDictionariesLoaded;
}
